import React, { useEffect, useRef } from 'react';
import SplitType from 'split-type';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const AnimatedText = ({ text, animationType = 'fade-up' }) => {
  const textRef = useRef(null);

  useEffect(() => {
    const split = new SplitType(textRef.current, {
      types: 'words, chars',
      tagName: 'span'
    });

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: textRef.current,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    });

    if (animationType === 'fade-up') {
      tl.from(split.words, {
        y: 20,
        opacity: 0,
        stagger: 0.3,
        duration: 0.8,
        ease: 'power2.out',
      });
    } else if (animationType === 'rotate') {
      tl.from(split.words, {
        rotateX: 90,
        // opacity: 0,
        stagger: 0.03,
        duration: 0.3,
        ease: 'back.out(1.7)',
      });
    } else if (animationType === 'scale') {
      tl.from(split.chars, {
        scale: 0,
        // opacity: 0,
        stagger: 0.05,
        duration: 0.5,
        ease: 'back.out(2)',
      });
    }

    return () => {
      split.revert();
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, [text, animationType]);

  return <span ref={textRef}>{text}</span>;
};

export default AnimatedText;
